import { COOKIE_FLARE_ANONYMOUS_ID_CONFIG } from "./cookie-flare-anonymous-id";
import { getCookieValue } from "./get-cookie-value";

interface Req {
  headers?: Record<string, string | string[] | undefined>;
}

export function getAnonymousIdFromCookies(req?: Req): string | null {
  return getCookieValue(COOKIE_FLARE_ANONYMOUS_ID_CONFIG.name, req) || null;
}

export function getAnonymousIdFromHeaders(req?: Req) {
  const value = req?.headers?.[`x-${COOKIE_FLARE_ANONYMOUS_ID_CONFIG.name}`];

  if (value === undefined || value === null) {
    return null;
  }

  if (Array.isArray(value)) {
    return value[0];
  }

  return value;
}

export function getAnonymousId(req?: Req) {
  const cookieValue = getAnonymousIdFromCookies(req);
  const headerValue = getAnonymousIdFromHeaders(req);

  return cookieValue || headerValue;
}
